module.exports = __webpack_public_path__ + "media/backgrounds/thilak-mohan-_LfLA5Nqfko-unsplash-d322166f.jpg";